
/**
 * 링크 유형 (외부 링크 또는 프로젝트 링크)
 */
export type GetExploreContent200PageAllOfThreeContentItemContentOneOfMediaLinksItemLinkType = typeof GetExploreContent200PageAllOfThreeContentItemContentOneOfMediaLinksItemLinkType[keyof typeof GetExploreContent200PageAllOfThreeContentItemContentOneOfMediaLinksItemLinkType];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetExploreContent200PageAllOfThreeContentItemContentOneOfMediaLinksItemLinkType = {
  EXTERNAL: 'EXTERNAL',
  PROJECT: 'PROJECT',
} as const;
